<template>
  <div class="header">
    <img src="@/assets/img/logo.svg" />
  </div>
</template>

<script>
export default {
  name: "heading",
  components: {},
  data() {}
};
</script>

<style>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 15px 0;
  background: #333;
  display: flex;
  justify-content: center;
}

.header img {
  height: 50px;
}
</style>
